import FavoritePage from "../components/home/FavoritePage";
import NotFound from "@/components/common/NotFound";
import { isProspect } from "@/utils/type";

function Favorite({ type }) {
    return isProspect(type) ? <FavoritePage /> : <NotFound />;
}

export async function getStaticProps() {
    return { props: { type: process.env.NEXT_PUBLIC_TYPE } };
}

export default Favorite;
